import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetCertificationAction } from '../../../../ts/ServerApi/types/actionNames';
import { setCertificationAction } from '../../../actions/spaces/SetCertificationAction';
import { IEntityAction } from './IEntityAction';

export const SetCertificationAction: IEntityAction<IContentInfo<'database'> | IContentInfo<'table'>, ISetCertificationAction> = {
    name: 'setCertification',
    translateName: Messages.editCertification,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.setCertificationEnabled,
    isClickable: (availableActions: ISetCertificationAction) => !!(availableActions && availableActions.setCertification),
    createReduxAction: (items) => {
      if (!items || items.length === 0 || items.length > 1) {
        throw new Error(Messages.setCertificationError());
      }

      return setCertificationAction(items[0]);
    }
  };
